'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import '../global.css'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'
import { browserLogger } from 'src/core/logger/browser'

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    browserLogger.error(error)
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang="en-GB">
      <body>
        <main className="flex min-h-screen flex-col items-center justify-center gap-4 p-4">
          <h1 className="text-2xl font-semibold">Something went wrong</h1>
          <p className="text-center text-neutral-600">
            Please try again or contact support if the problem continues.
          </p>
        </main>
      </body>
    </html>
  )
}
